import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import authService from '@/lib/services/authService';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Avatar from '@/components/Avatar.vue';

// Auth store

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const authStore = useAuthStore();
const { userInfo } = storeToRefs(authStore);

// Logout function
const logout = async () => {
	await authService.logout();
};

return { __sfc: true,authStore, userInfo, logout, Breadcrumb, Avatar }
}

})